/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Speakers_LabelInputs */

const en_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const fr_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locuteurs`)
};

const de_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher`)
};

const it_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altoparlanti`)
};

const ru_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Докладчики`)
};

const es_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oradores`)
};

const zh_cn2_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者`)
};

const ja_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`講演者`)
};

const hi_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं`)
};

const pt_pt2_editor_speakers_label = /** @type {(inputs: Editor_Speakers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestrantes`)
};

/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Editor_Speakers_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_speakers_label = /** @type {((inputs?: Editor_Speakers_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Speakers_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_speakers_label(inputs)
	if (locale === "de") return de_editor_speakers_label(inputs)
	if (locale === "it") return it_editor_speakers_label(inputs)
	if (locale === "ru") return ru_editor_speakers_label(inputs)
	if (locale === "es") return es_editor_speakers_label(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_speakers_label(inputs)
	if (locale === "ja") return ja_editor_speakers_label(inputs)
	if (locale === "hi") return hi_editor_speakers_label(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_speakers_label(inputs)
	return en_editor_speakers_label(inputs)
});